var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#48D821"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1673 15.2507V20.7507C27.1673 20.9615 27.1673 21.1631 27.149 21.3648C27.1123 21.3098 27.0665 21.2548 27.0206 21.209C27.0115 21.1998 27.0023 21.1815 26.9931 21.1723C26.2506 20.3473 25.1598 19.834 23.959 19.834C22.804 19.834 21.7498 20.3106 20.9982 21.0806C20.274 21.8231 19.834 22.8407 19.834 23.959C19.834 24.729 20.054 25.4623 20.4298 26.0857C20.6315 26.4248 20.8882 26.7365 21.1815 26.9931C21.1998 27.0023 21.209 27.0115 21.2181 27.0207C21.264 27.0665 21.3098 27.1031 21.3648 27.149C21.1723 27.1673 20.9615 27.1673 20.7507 27.1673H15.2507C10.6673 27.1673 8.83398 25.334 8.83398 20.7507V15.2507C8.83398 10.6673 10.6673 8.83398 15.2507 8.83398H20.7507C25.334 8.83398 27.1673 10.6673 27.1673 15.2507Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30859 13.5176H26.6886",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8105 8.93359V13.3886",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1914 8.93359V12.9761",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.084 23.959C28.084 24.289 28.0473 24.6098 27.9648 24.9215C27.864 25.334 27.699 25.7282 27.4882 26.0857C26.7732 27.2773 25.4623 28.084 23.959 28.084C22.969 28.084 22.0706 27.7356 21.374 27.149C21.3648 27.149 21.3648 27.149 21.3648 27.149C21.3098 27.1031 21.264 27.0665 21.2181 27.0207C21.209 27.0115 21.1998 27.0023 21.1815 26.9931C20.8882 26.7365 20.6315 26.4248 20.4298 26.0857C20.054 25.4623 19.834 24.729 19.834 23.959C19.834 22.8407 20.274 21.8231 20.9982 21.0806C21.7498 20.3106 22.804 19.834 23.959 19.834C25.1598 19.834 26.2506 20.3473 26.9931 21.1723C27.0023 21.1815 27.0115 21.1998 27.0206 21.209C27.0665 21.2548 27.1123 21.3098 27.149 21.3648C27.7356 22.0706 28.084 22.9782 28.084 23.959Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 23.9395H22.4199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.959 22.4355V25.5155",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.26e732b963b24f32da78a5124c96e02e.svg";
export { ForwardRef as ReactComponent };